import React from 'react'
import './AnimatedIcon.css'

function AnimatedPlus(props) {
  return (
    <svg className="svg" version="1.1" viewBox="0 0 130.2 130.2">
                    <circle className="path circle" fill="none" stroke="#73AF55" strokeWidth="6" strokeMiterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                    <line className="path line-delayed" fill="none" stroke="#73AF55" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" x1="65" y1="37.9" x2="65" y2="92.3" />
                    <line className="path line" fill="none" stroke="#73AF55" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" x1="35" y1="65" x2="95" y2="65" />
                </svg>
  )
}

export default AnimatedPlus
